import React, { FC, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { Flexbox, FlexboxVertical } from '../../Layout';
import { LinkButton } from '../../LinkButton';
import { Colors } from '../../../..';
import { DefaultInput as TextInput } from '../../forms/DefaultInput';
import { TextBox } from '../../forms/TextBox';
import { Note } from '../../../../interfaces/Operation';

const BoxWrapper = styled(FlexboxVertical)`
  & > *:nth-child(1) {
    padding-top: 0;
    max-width: 32rem;
    margin-bottom: 1.5rem;
  }
  
  & > *:nth-child(2) {
    padding-top: 0;
    margin-bottom: 1rem;
  }
`;

const HoverEffect = css`
  cursor: pointer;
  transition: color 150ms ease-out;
  
  &:hover {
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
`;

const ButtonsWrapper = styled(Flexbox)`
  & > * {
    margin-left: auto;
    
    ${HoverEffect}
    
    &:first-child {
      margin-left: 0;  
    }
  }
`;

interface Props {
  note?: Note | null;
  onSaveClick: (note: Note) => void;
  onCancelClick?: () => void;
}
export const NoteInputBox: FC<Props> = ({ note, onSaveClick, onCancelClick, ...props }) => {
  const [tmpNote, setTmpNote] = useState(note || { subject: '', body: '', timestamp: new Date().toISOString() });
  useEffect(() => setTmpNote(note), [note]);

  return (
    <BoxWrapper>

      <TextInput
        id={'note-input-subject'}
        placeholder={'Betreff/Stichwort'}
        onChange={(e) => setTmpNote({ ...tmpNote, subject: e.target.value })}
        value={tmpNote.subject}
      />

      <TextBox
        id={'note-input-body'}
        placeholder={'Notizen'}
        onChange={(e) => setTmpNote({ ...tmpNote, body: e.target.value })}
        value={tmpNote.body}
      />

      <ButtonsWrapper>
        <LinkButton onChangeHandler={onCancelClick}>Abbrechen</LinkButton>
        <LinkButton onChangeHandler={() => onSaveClick(tmpNote)}>Notiz speichern</LinkButton>
      </ButtonsWrapper>
    </BoxWrapper>
  )
}
